import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { RequestService } from 'src/app/services/request/request.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal2 from 'sweetalert2';
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import { NewPublicationButtonComponent } from 'src/app/components/common-elements/buttons/new-publication-button/new-publication-button.component';
import {InlineBowsingComponent} from 'src/app/inline-bowsing/inline-bowsing.component';
import { ModalController, ActionSheetController, } from '@ionic/angular';
import { IonSlides } from '@ionic/angular';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { getTrackSeoSlug, slugToSearchTerm } from 'src/app/utils/seo-slug';
import { Utils } from 'src/app/Models/Classes/utils';
import { NativeLiveActivities, NativeLiquidGlass } from 'src/app/plugins/native-runtime.plugins';
import { ClientSnapshotCacheService } from 'src/app/services/cache/client-snapshot-cache.service';

@Component({
  selector: 'app-lk-music-view',
  templateUrl: './lk-music-view.component.html',
  styleUrls: ['./lk-music-view.component.scss'],
})
export class LkMusicViewComponent implements OnInit, AfterViewInit, OnDestroy {
  user_top_data;
  searchTerm = 'Joachim';
  index=0;
private _loadingMore = false;
private _lastFetchAt = 0;
private terminalPlaylistPageLoaded = false;
private playlistWindowOffset = 0;
  private readonly loaderPhaseMs = 900;
  private loaderPhaseTimeout?: ReturnType<typeof setTimeout>;
    @ViewChild(IonSlides) slides: IonSlides;
    @ViewChild('songSlides') songSlides?: IonSlides;
    @ViewChild('nativeMusicSearchAnchor') nativeMusicSearchAnchor?: ElementRef<HTMLElement>;
    @ViewChild('nativeMusicPlayerAnchor') nativeMusicPlayerAnchor?: ElementRef<HTMLElement>;
    @ViewChild('spotifyEmbedHost') spotifyEmbedHost?: ElementRef<HTMLElement>;
    @ViewChildren(IonSlides) slideRefs: QueryList<IonSlides>;
  pageLoading = true;
  showPageSkeleton = false;
  wheelLock = false;
  private removeWheelListeners: Array<() => void> = [];
  private swipeOnboardingTimeout: ReturnType<typeof setTimeout> | null = null;
  private swipeOnboardingCloseTimeout: ReturnType<typeof setTimeout> | null = null;
  private swipeOnboardingStyleEl: HTMLStyleElement | null = null;
  private swipeOnboardingOverlayEl: HTMLDivElement | null = null;
  private currentRouteSlug: string | null = null;
  public nativeMusicSearchAvailable = false;
  private nativeMusicSearchListener?: PluginListenerHandle;
  private nativeMusicPlayerListener?: PluginListenerHandle;
  private nativeMusicPlayerSyncTimer?: ReturnType<typeof setInterval>;
  private musicLiveActivityOperation: Promise<void> = Promise.resolve();
  private musicLiveActivityActive = false;
  private musicLiveActivityLastSentAt = 0;
  private musicLiveActivityLastTrackId = '';
  private musicLiveActivityLastIsPlaying?: boolean;
  private pendingMusicActivityAction?: 'previous' | 'toggle' | 'next';
  private musicActivityActionNonce = '';
  private musicPlaybackStateReady = false;
  public nativeMusicPlayerAvailable = false;
  private nativeMusicSearchResizeObserver?: ResizeObserver;
  private nativeMusicSearchFrameSignature = '';
  private readonly nativeMusicSearchPositionHandler = () => this.syncNativeMusicSearch();
  private spotifySessionConfirmed = false;
  private spotifySessionKnown = false;
  private spotifySessionCheck?: Promise<boolean>;
  private previewAudio?: HTMLAudioElement;
  private previewTrackId?: string;
  private spotifyEmbedApi?: any;
  private spotifyEmbedController?: any;
  private spotifyEmbedApiPromise?: Promise<any>;
  private spotifyEmbedControllerPromise?: Promise<any>;
  private profileRequestId = 0;
  private trackEndRefreshInProgress = false;
  private trackEndRefreshGeneration = 0;
  private viewActive = false;
  private pendingShuffleState?: boolean;
  private pendingRepeatState?: 'off' | 'context' | 'track';
  private pendingShuffleExpiresAt = 0;
  private pendingRepeatExpiresAt = 0;
  private nowPlayingRequestInFlight = false;
  private spotifyPlaylistSongUris = new Set<string>();
  profilePlaylistTargetId?: number;
  nowPlaying = {
    album: {
      album_type: 'album',
      artists: [
        {
          external_urls: { spotify: 'https://open.spotify.com/artist/6eNOjuJSfKkAvbiGW90AkZ' },
          href: 'https://api.spotify.com/v1/artists/6eNOjuJSfKkAvbiGW90AkZ',
          id: '6eNOjuJSfKkAvbiGW90AkZ',
          name: 'Joachim Pastor',
          type: 'artist',
          uri: 'spotify:artist:6eNOjuJSfKkAvbiGW90AkZ',
        }
      ],
      external_urls: { spotify: 'https://open.spotify.com/album/2OZDADG33zm9rWRRnW2NLR' },
      href: 'https://api.spotify.com/v1/albums/2OZDADG33zm9rWRRnW2NLR',
      id: '2OZDADG33zm9rWRRnW2NLR',
      images: [
        { url:'https://i.scdn.co/image/ab67616d0000b27350bd66bd7d48ae20216def19'}
       
        // optional — add real URLs if you want cover art to show;
        // your template already falls back to /assets/placeholder.png
        // { url: 'https://i.scdn.co/image/...' },
      ],
      is_playable: true,
      name: 'The Winning Line',
      release_date: '2022-09-23',
      release_date_precision: 'day',
      total_tracks: 17,
      type: 'album',
      uri: 'spotify:album:2OZDADG33zm9rWRRnW2NLR',
    },

    artists: [
      {
        external_urls: { spotify: 'https://open.spotify.com/artist/6eNOjuJSfKkAvbiGW90AkZ' },
        href: 'https://api.spotify.com/v1/artists/6eNOjuJSfKkAvbiGW90AkZ',
        id: '6eNOjuJSfKkAvbiGW90AkZ',
        name: 'Joachim Pastor',
        type: 'artist',
        uri: 'spotify:artist:6eNOjuJSfKkAvbiGW90AkZ',
      }
    ],

    // track fields
    disc_number: 1,
    duration_ms: 166617,
    explicit: false,
    external_ids: { isrc: 'FR9W12221708' },
    external_urls: { spotify: 'https://open.spotify.com/track/5aZKMNDFRNu9CIKh1C1ChH' },
    href: 'https://api.spotify.com/v1/tracks/5aZKMNDFRNu9CIKh1C1ChH',
    id: '5aZKMNDFRNu9CIKh1C1ChH',
    is_local: false,
    is_playable: true,
    is_playing: false,     // <— you added this; used by your UI
    name: '17 Virages',
    popularity: 38,
    preview_url: null,
    progress_ms: 2000,    // <— progress bar will start at 00:02
    track_number: 16,
    type: 'track',
    uri: 'spotify:track:5aZKMNDFRNu9CIKh1C1ChH',
  } as any;
  default_device_id;
  private deviceSelectionConfirmed = false;
      slideOpts = {
    direction: 'vertical',
    initialSlide: 0,
    speed: 400,
  };
  playlists: any[] = [];
chunkedPlaylists: any[][] = [];
playlistsNext?: string | null;
playlistsPrev?: string | null;
songs;
chunked_songs;
playlistTotal = 0;
playlistLastPageLoading = false;
nowPlayingLoading = false;
spotifyDeviceLoading = false;
spotifyVolume = 50;
spotifyVolumeSupported = false;
spotifyVolumeRestricted = false;
spotifyVolumeLoading = false;
nowPlayingArtworkLoaded = false;
playerExpanded = false;
playerDetailsLoading = false;
albumTracks: any[] = [];
artistTracks: any[] = [];
showHistory = false;
musicHistory: any[] = [];
musicHistoryLoading = false;
private lastRecordedHistoryTrackId = '';
private historyRecordInFlight?: Promise<boolean>;
private readonly loadedTrackArtwork = new Set<string>();
private readonly artworkRetryCounts = new Map<string, number>();
  constructor( private request: RequestService,
        private router: Router,
            private formservice:FormServiceService,
             private NewPublication: NewPublicationButtonComponent,
               private modalController: ModalController,
               private actionSheetController: ActionSheetController,
               private route: ActivatedRoute,
               private utils: Utils,
               private readonly snapshotCache: ClientSnapshotCacheService,
  ) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      const targetId = Number(params.get('addToProfilePlaylist'));
      this.profilePlaylistTargetId = Number.isInteger(targetId) && targetId > 0 ? targetId : undefined;
      const action = params.get('activityAction');
      const nonce = params.get('activityNonce') || '';
      if ((action === 'previous' || action === 'toggle' || action === 'next') && nonce && nonce !== this.musicActivityActionNonce) {
        this.musicActivityActionNonce = nonce;
        this.pendingMusicActivityAction = action;
        this.runPendingMusicActivityAction();
      } else if (!action || !nonce) {
        // Live Activity Links keep their URL until ActivityKit renders a new
        // state. Allow the same control URL to be used again after we consume it.
        this.musicActivityActionNonce = '';
      }
    });
    if (Capacitor.getPlatform() === 'ios') {
      NativeLiquidGlass.addListener('lkMusicSearchAction', ({ action, query }) => {
        if (action !== 'submitSearch') return;
        const value = String(query || '').trim();
        this.onSearchChange({ detail: { value } });
      }).then(listener => this.nativeMusicSearchListener = listener).catch(() => undefined);
      NativeLiquidGlass.addListener('lkMusicPlayerAction', ({ action, positionMs, volumePercent }) => {
        if (action === 'playPause') void this.togglePlay();
        if (action === 'previous') void this.player('previous_song');
        if (action === 'next') void this.player('next_song');
        if (action === 'seek') void this.seekToPosition(Number(positionMs) || 0);
        if (action === 'changeDevice') void this.changeSpotifyPlaybackDevice();
        if (action === 'fetchNowPlaying') void this.fetchNowPlaying();
        if (action === 'toggleShuffle') void this.player('toggle_shuffle');
        if (action === 'toggleRepeat') void this.player('toggle_repeat');
        if (action === 'setVolume') void this.setSpotifyVolume(Number(volumePercent));
        if (action === 'openDetails') void this.openNowPlayingDetails();
      }).then(listener => this.nativeMusicPlayerListener = listener).catch(() => undefined);
    }
    this.route.paramMap.subscribe((params) => {
      this.currentRouteSlug = params.get('slug');
      const searchTerm = this.currentRouteSlug ? slugToSearchTerm(this.currentRouteSlug) : 'Joachim';
      this.searchTerm = searchTerm || 'Joachim';
      this.loadTracks(this.searchTerm, this.currentRouteSlug);
    });
  }
  ngAfterViewInit() {
    this.bindWheelToAllSlides();
    this.slideRefs?.changes.subscribe(() => setTimeout(() => this.bindWheelToAllSlides(), 0));
    if (Capacitor.getPlatform() === 'ios') {
      setTimeout(() => this.installNativeMusicSearchPositioning(), 0);
      setTimeout(() => this.startNativeMusicPlayer(), 0);
    }
  }

  ionViewWillEnter() {
    // Device choice is intentionally scoped to one LK Music visit. Ionic may
    // cache the component between tabs, so reset it whenever the view opens.
    this.default_device_id = undefined;
    this.deviceSelectionConfirmed = false;
    this.viewActive = true;
    this.musicPlaybackStateReady = false;
  }

  ionViewDidEnter() {
    void this.loadNowPlayingOnEntry().finally(() => {
      this.musicPlaybackStateReady = true;
      this.runPendingMusicActivityAction();
    });
  }

  private runPendingMusicActivityAction(): void {
    if (!this.viewActive || !this.musicPlaybackStateReady || !this.pendingMusicActivityAction) return;
    const action = this.pendingMusicActivityAction;
    this.pendingMusicActivityAction = undefined;
    void this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { activityAction: null, activityNonce: null },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    }).catch(() => undefined);

    if (action === 'previous') void this.player('previous_song');
    else if (action === 'next') void this.player('next_song');
    else void this.togglePlay();
  }

  ionViewWillLeave() {
    this.viewActive = false;
    this.trackEndRefreshGeneration++;
    this.trackEndRefreshInProgress = false;
    this.clearProgressTimer();
  }

  private async loadNowPlayingOnEntry(): Promise<void> {
    const session = await this.checkSpotifySessionWithoutPrompt();
    if (session.authenticated) {
      await this.fetchNowPlaying();
      return;
    }

    await this.prepareSpotifyEmbed(this.nowPlaying);
  }

  ngOnDestroy() {
    this.viewActive = false;
    this.trackEndRefreshGeneration++;
    this.stopPreviewPlayback();
    this.destroySpotifyEmbed();
    this.clearProgressTimer();
    this.nativeMusicSearchResizeObserver?.disconnect();
    window.removeEventListener('scroll', this.nativeMusicSearchPositionHandler, true);
    window.removeEventListener('resize', this.nativeMusicSearchPositionHandler);
    this.nativeMusicSearchListener?.remove();
    this.nativeMusicPlayerListener?.remove();
    if (this.nativeMusicPlayerSyncTimer) clearInterval(this.nativeMusicPlayerSyncTimer);
    NativeLiquidGlass.setRegion({ region: 'lk-music-search', visible: false }).catch(() => undefined);
    NativeLiquidGlass.setRegion({ region: 'lk-music-player', visible: false }).catch(() => undefined);
    this.removeGlobalSwipeOnboarding(true);
    this.clearWheelListeners();
  }

  private installNativeMusicSearchPositioning(): void {
    const anchor = this.nativeMusicSearchAnchor?.nativeElement;
    if (!anchor) return;

    this.nativeMusicSearchResizeObserver?.disconnect();
    this.nativeMusicSearchResizeObserver = new ResizeObserver(() => this.syncNativeMusicSearch());
    this.nativeMusicSearchResizeObserver.observe(anchor);
    window.addEventListener('scroll', this.nativeMusicSearchPositionHandler, true);
    window.addEventListener('resize', this.nativeMusicSearchPositionHandler);
    this.syncNativeMusicSearch(true);
  }

  private syncNativeMusicSearch(force = false): void {
    if (Capacitor.getPlatform() !== 'ios') return;
    const anchor = this.nativeMusicSearchAnchor?.nativeElement;
    const visible = Boolean(anchor && !this.show_profile_page);
    if (!anchor) {
      NativeLiquidGlass.setRegion({ region: 'lk-music-search', visible: false }).catch(() => undefined);
      return;
    }

    const rect = anchor.getBoundingClientRect();
    const state = {
      visible,
      x: rect.left,
      y: rect.top,
      width: rect.width,
      height: rect.height,
      query: this.searchTerm || '',
    };
    const signature = JSON.stringify(state);
    if (!force && signature === this.nativeMusicSearchFrameSignature) return;
    this.nativeMusicSearchFrameSignature = signature;

    NativeLiquidGlass.setRegion({ region: 'lk-music-search', ...state })
      .then(({ available }) => this.nativeMusicSearchAvailable = available && visible)
      .catch(() => this.nativeMusicSearchAvailable = false);
  }

  private startNativeMusicPlayer(): void {
    if (Capacitor.getPlatform() !== 'ios') return;
    this.syncNativeMusicPlayer();
    this.nativeMusicPlayerSyncTimer = setInterval(() => this.syncNativeMusicPlayer(), 400);
  }

  private syncNativeMusicPlayer(): void {
    if (this.playerExpanded) {
      NativeLiquidGlass.setRegion({ region: 'lk-music-player', visible: false }).catch(() => undefined);
      this.nativeMusicPlayerAvailable = false;
      return;
    }
    const anchor = this.nativeMusicPlayerAnchor?.nativeElement;
    if (!anchor || !this.nowPlaying) {
      NativeLiquidGlass.setRegion({ region: 'lk-music-player', visible: false }).catch(() => undefined);
      return;
    }
    const rect = anchor.getBoundingClientRect();
    NativeLiquidGlass.setRegion({
      region: 'lk-music-player',
      visible: rect.width > 0 && rect.height > 0,
      x: rect.left,
      y: rect.top,
      width: rect.width,
      height: rect.height,
      title: this.nowPlaying?.name || '',
      artist: (this.nowPlaying?.artists || []).map((artist: any) => artist?.name).filter(Boolean).join(', '),
	  artworkUrl: this.getNowPlayingArtworkUrl() || '',
      durationMs: Number(this.nowPlaying?.duration_ms) || 0,
      progressMs: Number(this.nowPlaying?.progress_ms) || 0,
      isPlaying: Boolean(this.nowPlaying?.is_playing),
      shuffle: Boolean(this.nowPlaying?.shuffle_state),
      repeatState: this.nowPlaying?.repeat_state || 'off',
      volumePercent: this.spotifyVolume,
      volumeSupported: this.spotifyVolumeSupported,
      volumeRestricted: this.spotifyVolumeRestricted,
    }).then(({ available }) => this.nativeMusicPlayerAvailable = available)
      .catch(() => this.nativeMusicPlayerAvailable = false);
  }

  getNowPlayingArtworkUrl(): string | null {
    return this.getNowPlayingArtworkCandidates()[0] || null;
  }

  handleNowPlayingArtworkError(event: Event): void {
    this.nowPlayingArtworkLoaded = false;
    this.retryArtworkImage(event.target as HTMLImageElement, this.getNowPlayingArtworkCandidates(), 'now-playing');
  }

  markNowPlayingArtworkLoaded(event: Event): void {
    this.nowPlayingArtworkLoaded = true;
    this.resetArtworkRetry(event.target as HTMLImageElement, 'now-playing');
  }

  getTrackArtworkUrl(track: any): string | null {
    return this.getTrackArtworkCandidates(track)[0] || null;
  }

  handleTrackArtworkError(event: Event, track: any): void {
    const key = this.trackArtworkKey(track);
    this.loadedTrackArtwork.delete(key);
    this.retryArtworkImage(event.target as HTMLImageElement, this.getTrackArtworkCandidates(track), key);
  }

  markTrackArtworkLoaded(event: Event, track: any): void {
    const key = this.trackArtworkKey(track);
    this.loadedTrackArtwork.add(key);
    this.resetArtworkRetry(event.target as HTMLImageElement, key);
  }

  isTrackArtworkLoaded(track: any): boolean {
    return this.loadedTrackArtwork.has(this.trackArtworkKey(track));
  }

  handlePlaylistArtworkError(event: Event): void {
    const image = event.target as HTMLImageElement;
    if (!image.src.endsWith('/assets/images/ecosystem/SVG/lk-music.svg')) {
      image.src = 'assets/images/ecosystem/SVG/lk-music.svg';
    }
  }

  private getTrackArtworkCandidates(track: any): string[] {
    const albumImages = Array.isArray(track?.album?.images) ? track.album.images : [];
    const trackImages = Array.isArray(track?.images) ? track.images : [];
    // Spotify returns 640px, 300px, and 64px variants. A 300px tile cover is
    // visually sufficient here and avoids downloading every largest asset.
    const orderedImages = [albumImages[1], albumImages[0], albumImages[2], ...trackImages];
    return orderedImages
      .map((image: any) => typeof image === 'string' ? image : image?.url)
      .filter((url: any, index: number, urls: any[]) =>
        typeof url === 'string' && /^https?:\/\//i.test(url) && urls.indexOf(url) === index
      );
  }

  private trackArtworkKey(track: any): string {
    return String(track?.id || track?.uri || `${track?.name || 'track'}:${track?.artists?.[0]?.name || ''}`);
  }

  private retryArtworkImage(image: HTMLImageElement, candidates: string[], key: string): void {
    if (!candidates.length) return;
    const candidateIndex = Number(image.dataset['artworkCandidate'] || 0);
    if (candidateIndex + 1 < candidates.length) {
      image.dataset['artworkCandidate'] = String(candidateIndex + 1);
      image.src = candidates[candidateIndex + 1];
      return;
    }

    const retryCount = this.artworkRetryCounts.get(key) || 0;
    if (retryCount >= 3) return;
    this.artworkRetryCounts.set(key, retryCount + 1);
    image.dataset['artworkCandidate'] = '0';
    setTimeout(() => {
      const separator = candidates[0].includes('?') ? '&' : '?';
      image.src = `${candidates[0]}${separator}lk_retry=${retryCount + 1}`;
    }, 500 * (retryCount + 1));
  }

  private resetArtworkRetry(image: HTMLImageElement, key: string): void {
    image.dataset['artworkCandidate'] = '0';
    this.artworkRetryCounts.delete(key);
  }

  private getNowPlayingArtworkCandidates(): string[] {
    const imageSources = [
      ...(Array.isArray(this.nowPlaying?.album?.images) ? this.nowPlaying.album.images : []),
      ...(Array.isArray((this.nowPlaying as any)?.images) ? (this.nowPlaying as any).images : []),
      (this.nowPlaying as any)?.artwork_url,
      (this.nowPlaying as any)?.artworkUrl,
      (this.nowPlaying as any)?.image_url,
      (this.nowPlaying as any)?.imageUrl,
    ];

    return imageSources
      .map((image: any) => typeof image === 'string' ? image : image?.url)
      .filter((url: any, index: number, urls: any[]) =>
        typeof url === 'string' && /^https?:\/\//i.test(url) && urls.indexOf(url) === index
      );
  }

  @HostListener('document:click')
  @HostListener('document:touchstart')
  onPageInteraction() {
    this.removeGlobalSwipeOnboarding();
  }


  private async launchGlobalSwipeOnboarding() {
    if (typeof document === 'undefined') {
      return;
    }

    if (this.formservice.globalSwipeOnboardingShown) {
      return;
    }

    this.formservice.globalSwipeOnboardingShown = true;
    const shouldShowOnboarding = await this.utils.consumeOneTimeFlag('global_swipe_onboarding_shown');
    if (!shouldShowOnboarding) {
      return;
    }

    this.removeGlobalSwipeOnboarding(true);

    const style = document.createElement('style');
    style.id = 'lk-global-swipe-onboarding-style';
    style.textContent = `
      .lk-global-swipe-onboarding {
        position: fixed;
        inset: 0;
        z-index: 2147483646;
        background: #f6f6f6;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        animation: lkPagePeek 1.8s ease-in-out infinite;
        transform: translateY(0);
        will-change: transform;
      }

      .lk-global-swipe-onboarding.lk-exit {
        animation: lkExitToTop 420ms ease-in forwards !important;
      }

      .lk-global-swipe-onboarding__title {
        position: absolute;
        top: 14vh;
        margin: 0;
        text-align: center;
        font-size: clamp(34px, 7vw, 46px);
        line-height: 1.05;
        font-weight: 800;
        color: #000;
      }

      .lk-global-swipe-onboarding__title span { display: block; }

      .lk-global-swipe-onboarding__card {
        width: 148px;
        height: 248px;
        border-radius: 28px;
        background: #bdbdbd;
        box-shadow: inset 0 3px 0 rgba(255,255,255,0.35);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .lk-global-swipe-onboarding__play {
        width: 0;
        height: 0;
        border-top: 15px solid transparent;
        border-bottom: 15px solid transparent;
        border-left: 22px solid #e7e7e7;
        margin-left: 8px;
      }

      .lk-global-swipe-onboarding__pill {
        position: absolute;
        bottom: 12px;
        width: 26px;
        height: 3px;
        border-radius: 999px;
        background: #d9d9d9;
      }

      .lk-global-swipe-onboarding__hand {
        position: absolute;
        right: -52px;
        top: 112px;
        width: 84px;
        height: 84px;
        border-radius: 48px;
        border: 2px solid #222;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        animation: lkSwipeHand 1s ease-in-out infinite;
      }

      .lk-global-swipe-onboarding__hand ion-icon {
        font-size: 40px;
        color: #222;
      }

      .lk-global-swipe-onboarding__chevrons {
        position: absolute;
        bottom: 15vh;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      .lk-global-swipe-onboarding__chevrons span {
        width: 10px;
        height: 10px;
        border-top: 2px solid #333;
        border-left: 2px solid #333;
        transform: rotate(45deg);
        opacity: 0;
        animation: lkChevronPulse 1s ease-in-out infinite;
      }

      .lk-global-swipe-onboarding__chevrons span:nth-child(2) { animation-delay: 0.15s; }
      .lk-global-swipe-onboarding__chevrons span:nth-child(3) { animation-delay: 0.3s; }

      @keyframes lkSwipeHand {
        0%,100% { transform: translate(0,0) scale(1); }
        35% { transform: translate(-8px,-16px) scale(0.98); }
      }

      @keyframes lkChevronPulse {
        0% { opacity: 0; transform: translateY(6px) rotate(45deg); }
        45% { opacity: 1; transform: translateY(-4px) rotate(45deg); }
        100% { opacity: 0; transform: translateY(-10px) rotate(45deg); }
      }

      @keyframes lkExitToTop {
        0% { transform: translateY(0); opacity: 1; }
        100% { transform: translateY(-100%); opacity: 1; }
      }

      @keyframes lkPagePeek {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-32px); }
      }
    `;

    const overlay = document.createElement('div');
    overlay.className = 'lk-global-swipe-onboarding';
    overlay.innerHTML = `
      <h2 class="lk-global-swipe-onboarding__title">Swipe up to start<span>watching</span></h2>
      <div class="lk-global-swipe-onboarding__card">
        <div class="lk-global-swipe-onboarding__play"></div>
        <div class="lk-global-swipe-onboarding__pill"></div>
        <div class="lk-global-swipe-onboarding__hand"><ion-icon name="hand-left-outline"></ion-icon></div>
      </div>
      <div class="lk-global-swipe-onboarding__chevrons" aria-hidden="true">
        <span></span><span></span><span></span>
      </div>
    `;

    document.head.appendChild(style);
    document.body.appendChild(overlay);

    this.swipeOnboardingStyleEl = style;
    this.swipeOnboardingOverlayEl = overlay;

    this.swipeOnboardingTimeout = setTimeout(() => {
      this.removeGlobalSwipeOnboarding();
    }, 5300);
  }

  private removeGlobalSwipeOnboarding(immediate = false) {
    if (this.swipeOnboardingTimeout) {
      clearTimeout(this.swipeOnboardingTimeout);
      this.swipeOnboardingTimeout = null;
    }

    if (this.swipeOnboardingCloseTimeout) {
      clearTimeout(this.swipeOnboardingCloseTimeout);
      this.swipeOnboardingCloseTimeout = null;
    }

    const overlay = this.swipeOnboardingOverlayEl;

    if (overlay && !immediate && !overlay.classList.contains('lk-exit')) {
      overlay.classList.add('lk-exit');
      this.swipeOnboardingCloseTimeout = setTimeout(() => {
        this.removeGlobalSwipeOnboarding(true);
      }, 420);
      return;
    }

    if (overlay?.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
    this.swipeOnboardingOverlayEl = null;

    if (this.swipeOnboardingStyleEl?.parentNode) {
      this.swipeOnboardingStyleEl.parentNode.removeChild(this.swipeOnboardingStyleEl);
    }
    this.swipeOnboardingStyleEl = null;
  }

  bindWheelToAllSlides() {
    this.clearWheelListeners();
    const refs = this.slideRefs?.toArray() ?? [];
    refs.forEach((slideRef) => {
      const el = (slideRef as any)?.el as HTMLElement;
      if (!el) return;
      const direction = ((slideRef as any)?.options?.direction === 'vertical') ? 'vertical' : 'horizontal';
      const axisDominance = 1.2;
      const threshold = 24;
      const wheelHandler = async (e: WheelEvent) => {
        if (this.wheelLock) return;
        const dx = e.deltaX;
        const dy = e.deltaY;
        const absX = Math.abs(dx);
        const absY = Math.abs(dy);
        const isVerticalIntent = absY > threshold && absY > absX * axisDominance;
        const isHorizontalIntent = absX > threshold && absX > absY * axisDominance;
        if (direction === 'vertical' && !isVerticalIntent) return;
        if (direction === 'horizontal' && !isHorizontalIntent) return;
        e.preventDefault();
        this.wheelLock = true;
        const amount = direction === 'vertical' ? dy : dx;
        if (amount > 0) {
          await slideRef.slideNext();
        } else if (amount < 0) {
          await slideRef.slidePrev();
        }
        setTimeout(() => (this.wheelLock = false), 330);
      };
      el.addEventListener('wheel', wheelHandler, { passive: false });
      this.removeWheelListeners.push(() => el.removeEventListener('wheel', wheelHandler as EventListener));
    });
  }

  clearWheelListeners() {
    this.removeWheelListeners.forEach(removeFn => removeFn());
    this.removeWheelListeners = [];
  }
  private chunk<T>(arr: T[], size: number): T[][] {
    const out: T[][] = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
  }

  private parseSpotifySearchResponse(data: any): any[] {
    if (data && typeof data === 'string') {
      try {
        data = JSON.parse(data);
        console.log('getRecordByToken ios:', data);
      } catch (error) {
        console.error('Error parsing data:', error);
      }
    }

    return data?.data?.tracks?.items ?? [];
  }

  private selectTrackFromSlug(routeSlug?: string | null) {
    if (!routeSlug || !Array.isArray(this.songs) || !this.songs.length) {
      return;
    }

    const exactTrack = this.songs.find((song) => getTrackSeoSlug(song) === routeSlug) || this.songs[0];
    if (exactTrack) {
      this.nowPlaying = {
        ...exactTrack,
        is_playing: false,
        progress_ms: exactTrack?.progress_ms || 0,
      } as any;
    }
  }

  private loadTracks(searchTerm: string, routeSlug?: string | null) {
    const snapshotKey = this.snapshotCache.key('lk-music-search', {
      searchTerm: String(searchTerm || '').trim().toLowerCase(),
      market: 'MX',
    });
    this.startPageLoading();
    this.show_playlists = false;

    const cachedSongs = this.snapshotCache.get<any[]>(snapshotKey, 30 * 60 * 1000);
    if (cachedSongs?.length) {
      this.songs = cachedSongs;
      this.chunked_songs = this.chunk(this.songs, 4);
      this.selectTrackFromSlug(routeSlug);
      this.finishPageLoading();
      this.bindWheelToAllSlides();
    }

    this.request.createRequestPost('spotify_search', { text: searchTerm, market: 'MX' }).then((data) => {
      this.songs = this.parseSpotifySearchResponse(data);
      this.snapshotCache.set(snapshotKey, this.songs || []);
      this.chunked_songs = this.chunk(this.songs, 4);
      this.selectTrackFromSlug(routeSlug);
      this.launchGlobalSwipeOnboarding();
    }).catch((error) => {
      console.log(error);
    }).finally(() => {
      this.finishPageLoading();
      this.bindWheelToAllSlides();
    });
  }

  async openNowPlayingDetails(): Promise<void> {
    if (!this.nowPlaying) return;
    this.playerExpanded = true;
    if (Capacitor.getPlatform() === 'ios') {
      NativeLiquidGlass.setRegion({ region: 'lk-music-player', visible: false }).catch(() => undefined);
      this.nativeMusicPlayerAvailable = false;
    }
    this.playerDetailsLoading = true;
    this.albumTracks = [];
    this.artistTracks = [];
    const albumName = String(this.nowPlaying?.album?.name || '').trim();
    const artistName = String(this.nowPlaying?.artists?.[0]?.name || '').trim();
    try {
      const [albumResult, artistResult] = await Promise.all([
        albumName ? this.request.createRequestPost('spotify_search', { text: `album:${albumName}`, market: 'MX' }) : Promise.resolve(null),
        artistName ? this.request.createRequestPost('spotify_search', { text: `artist:${artistName}`, market: 'MX' }) : Promise.resolve(null),
      ]);
      const albumId = String(this.nowPlaying?.album?.id || '');
      this.albumTracks = this.parseSpotifySearchResponse(albumResult)
        .filter((track: any) => !albumId || String(track?.album?.id || '') === albumId)
        .slice(0, 20);
      this.artistTracks = this.parseSpotifySearchResponse(artistResult)
        .filter((track: any) => String(track?.id || '') !== String(this.nowPlaying?.id || ''))
        .slice(0, 12);
    } finally {
      this.playerDetailsLoading = false;
    }
  }

  closeNowPlayingDetails(): void {
    if (!this.playerExpanded) return;
    this.playerExpanded = false;
    setTimeout(() => this.syncNativeMusicPlayer(), 0);
  }

  openNowPlayingArtist(): void {
    const artist = String(this.nowPlaying?.artists?.[0]?.name || '').trim();
    if (!artist) return;
    this.closeNowPlayingDetails();
    this.showHistory = false;
    this.show_playlists = false;
    this.show_profile_page = false;
    this.searchTerm = artist;
    this.index = 0;
    this.loadTracks(`artist:${artist}`);
    this.syncNativeMusicSearch(true);
  }

  async openNowPlayingAlbum(): Promise<void> {
    const albumName = String(this.nowPlaying?.album?.name || '').trim();
    const albumId = String(this.nowPlaying?.album?.id || '');
    if (!albumName && !albumId) return;
    this.closeNowPlayingDetails();
    this.showHistory = false;
    this.show_playlists = false;
    this.show_profile_page = false;
    // An album must not masquerade as a Spotify playlist: playlist pagination
    // and playback-context endpoints use different URI types.
    this.current_playlist = undefined;
    this.searchTerm = albumName;
    this.index = 0;
    this.startPageLoading();
    try {
      const response = await this.request.createRequestPost('spotify_search', {
        text: `album:${albumName}`,
        market: 'MX',
      });
      const matches = this.parseSpotifySearchResponse(response);
      const exactAlbumTracks = matches.filter((track: any) =>
        !albumId || String(track?.album?.id || '') === albumId
      );
      this.songs = exactAlbumTracks.length ? exactAlbumTracks : matches;
      this.chunked_songs = this.chunk(this.songs, 4);
      this.playlistTotal = this.songs.length;
    } catch (error) {
      console.error('Unable to open the current album.', error);
    } finally {
      this.finishPageLoading();
      this.bindWheelToAllSlides();
      this.syncNativeMusicSearch(true);
    }
  }

  async addNowPlayingToSpotifyPlaylist(): Promise<void> {
    if (this.nowPlaying?.uri) await this.chooseSpotifyPlaylist({ ...this.nowPlaying });
  }

  isSongInSpotifyPlaylist(song: any): boolean {
    const uri = String(song?.uri || '').trim();
    return uri !== '' && this.spotifyPlaylistSongUris.has(uri);
  }

  async openHistory(): Promise<void> {
    this.profileRequestId++;
    this.show_profile_page = false;
    this.show_playlists = false;
    this.showHistory = true;
    this.musicHistoryLoading = true;
    try {
      await this.recordPlayedSong(this.nowPlaying, true);
      let data: any = await this.request.createRequestPost('spotify_search_auth', { music_history: true, limit: 100 });
      data = this.parseSpotifyAuthResponse(data);
      data = this.parseSpotifyAuthResponse(data?.body ?? data);
      this.musicHistory = Array.isArray(data?.items) ? data.items : [];
    } catch (error) {
      console.error('Unable to load LK Music history.', error);
      this.musicHistory = [];
    } finally {
      this.musicHistoryLoading = false;
    }
  }

  private recordPlayedSong(track: any, force = false): Promise<boolean> {
    const trackId = String(track?.id || track?.uri || '');
    if (!trackId) return Promise.resolve(false);
    if (!force && trackId === this.lastRecordedHistoryTrackId) return Promise.resolve(true);
    if (this.historyRecordInFlight) return this.historyRecordInFlight;

    this.historyRecordInFlight = this.request.createRequestPost('spotify_search_auth', {
        record_music_history: true,
        track: {
          spotify_track_id: track?.id || null,
          uri: track?.uri || null,
          name: track?.name || '',
          artists: track?.artists || [],
          album: track?.album || null,
          duration_ms: Number(track?.duration_ms) || 0,
          explicit: Boolean(track?.explicit),
        },
      })
      .then((raw: any) => {
        let data = this.parseSpotifyAuthResponse(raw);
        data = this.parseSpotifyAuthResponse(data?.body ?? data);
        if (data?.ok !== true) throw new Error(data?.message || 'History write was not confirmed.');
        this.lastRecordedHistoryTrackId = trackId;
        return true;
      })
      .catch((error: any) => {
        this.lastRecordedHistoryTrackId = '';
        console.error('Unable to record LK Music history.', error?.error || error);
        return false;
      })
      .finally(() => { this.historyRecordInFlight = undefined; });

    return this.historyRecordInFlight;
  }
  show_profile_page;
  private parseSpotifyAuthResponse(data: any): any {
    if (typeof data !== 'string') return data || {};
    try {
      return JSON.parse(data);
    } catch {
      return {};
    }
  }

  private async showSpotifyLoginPrompt(loginUrl: string, previewPlaying = false): Promise<void> {
    if (!loginUrl) return;
    const sheet = await this.actionSheetController.create({
      header: 'Connect Spotify',
      subHeader: previewPlaying
        ? 'A short preview is playing. Connect Spotify for the complete song.'
        : 'Connect Spotify to play the complete song.',
      cssClass: 'lk-music-action-sheet',
      buttons: [
        {
          text: 'Open Spotify login',
          icon: 'logo-spotify',
          handler: () => {
            this.stopPreviewPlayback(false);
            this.pauseSpotifyEmbed();
            void this.openBrowser(loginUrl);
          },
        },
        {
          text: 'Not now',
          icon: 'close',
          role: 'cancel',
        },
      ],
    });
    await sheet.present();
  }

  private async checkSpotifySessionWithoutPrompt(): Promise<{ authenticated: boolean; loginUrl: string }> {
    if (this.spotifySessionConfirmed) {
      this.spotifySessionKnown = true;
      return { authenticated: true, loginUrl: '' };
    }

    try {
      const raw = await this.request.createRequestPost('spotify_search_auth', { oauth_log_in: true });
      const data = this.parseSpotifyAuthResponse(raw);
      if (Array.isArray(data?.items)) {
        this.spotifySessionConfirmed = true;
        this.spotifySessionKnown = true;
        return { authenticated: true, loginUrl: '' };
      }

      this.spotifySessionKnown = true;
      return {
        authenticated: false,
        loginUrl: typeof data?.login === 'string' ? data.login : this.buildSpotifyLoginUrl(),
      };
    } catch (error) {
      console.warn('Unable to confirm Spotify session; using preview playback.', error);
      this.spotifySessionKnown = true;
      return { authenticated: false, loginUrl: this.buildSpotifyLoginUrl() };
    }
  }

  private stopPreviewPlayback(resetProgress = true): void {
    if (this.previewAudio) {
      this.previewAudio.pause();
      this.previewAudio.src = '';
      this.previewAudio.load();
      this.previewAudio = undefined;
    }
    this.previewTrackId = undefined;
    if (this.nowPlaying?.preview_mode) {
      this.nowPlaying.is_playing = false;
      if (resetProgress) this.nowPlaying.progress_ms = 0;
    }
  }

  private playPreview(song: any): boolean {
    const previewUrl = typeof song?.preview_url === 'string' ? song.preview_url.trim() : '';
    if (!previewUrl) return false;

    this.stopPreviewPlayback();
    this.clearProgressTimer();
    this.nowPlaying = {
      ...song,
      is_playing: false,
      preview_mode: true,
      progress_ms: 0,
      full_duration_ms: song?.duration_ms,
      duration_ms: 30000,
    };

    const audio = new Audio(previewUrl);
    audio.preload = 'auto';
    this.previewAudio = audio;
    this.previewTrackId = song?.id || song?.uri;

    audio.addEventListener('loadedmetadata', () => {
      if (this.previewAudio !== audio || !Number.isFinite(audio.duration)) return;
      this.nowPlaying.duration_ms = Math.round(audio.duration * 1000);
      if (this.musicLiveActivityActive) this.syncMusicLiveActivity(true);
    });
    audio.addEventListener('timeupdate', () => {
      if (this.previewAudio !== audio || !this.nowPlaying) return;
      this.nowPlaying.progress_ms = Math.round(audio.currentTime * 1000);
    });
    audio.addEventListener('play', () => {
      if (this.previewAudio === audio && this.nowPlaying) {
        this.nowPlaying.is_playing = true;
        this.musicLiveActivityActive = true;
        this.syncMusicLiveActivity(true);
      }
    });
    const finish = () => {
      if (this.previewAudio !== audio || !this.nowPlaying) return;
      this.nowPlaying.is_playing = false;
      if (audio.ended) {
        this.nowPlaying.progress_ms = this.nowPlaying.duration_ms;
        this.endMusicLiveActivity();
      } else if (this.musicLiveActivityActive) {
        this.syncMusicLiveActivity(true);
      }
    };
    audio.addEventListener('pause', finish);
    audio.addEventListener('ended', finish);
    audio.addEventListener('error', () => {
      if (this.previewAudio !== audio) return;
      this.stopPreviewPlayback();
      this.endMusicLiveActivity();
      Swal2.fire({
        title: 'Preview unavailable',
        text: 'Spotify did not provide a playable preview for this song.',
        icon: 'info',
        toast: true,
        position: 'top',
        timer: 3500,
        showConfirmButton: false,
      });
    });

    audio.play().catch((error) => {
      console.warn('Spotify preview playback was blocked or failed.', {
        error,
        trackId: this.previewTrackId,
        previewUrl,
      });
      if (this.previewAudio === audio) this.nowPlaying.is_playing = false;
    });
    return true;
  }

  private loadSpotifyIframeApi(): Promise<any> {
    if (this.spotifyEmbedApi) return Promise.resolve(this.spotifyEmbedApi);
    const spotifyWindow = window as any;
    if (spotifyWindow.__laniakeaSpotifyIframeApi) {
      this.spotifyEmbedApi = spotifyWindow.__laniakeaSpotifyIframeApi;
      return Promise.resolve(this.spotifyEmbedApi);
    }
    if (this.spotifyEmbedApiPromise) return this.spotifyEmbedApiPromise;

    this.spotifyEmbedApiPromise = new Promise((resolve, reject) => {
      const previousReady = spotifyWindow.onSpotifyIframeApiReady;
      spotifyWindow.onSpotifyIframeApiReady = (api: any) => {
        spotifyWindow.__laniakeaSpotifyIframeApi = api;
        this.spotifyEmbedApi = api;
        if (typeof previousReady === 'function') previousReady(api);
        resolve(api);
      };

      const existing = document.querySelector<HTMLScriptElement>(
        'script[src="https://open.spotify.com/embed/iframe-api/v1"]'
      );
      if (existing) {
        existing.addEventListener('error', () => reject(new Error('Spotify iFrame API failed to load')), { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://open.spotify.com/embed/iframe-api/v1';
      script.async = true;
      script.addEventListener('error', () => reject(new Error('Spotify iFrame API failed to load')), { once: true });
      document.body.appendChild(script);
    }).finally(() => {
      this.spotifyEmbedApiPromise = undefined;
    });

    return this.spotifyEmbedApiPromise;
  }

  private async prepareSpotifyEmbed(song: any): Promise<any | null> {
    const uri = typeof song?.uri === 'string' ? song.uri : '';
    const host = this.spotifyEmbedHost?.nativeElement;
    if (!uri || !host) return null;
    if (this.spotifyEmbedController) return this.spotifyEmbedController;
    if (this.spotifyEmbedControllerPromise) return this.spotifyEmbedControllerPromise;

    this.spotifyEmbedControllerPromise = this.loadSpotifyIframeApi()
      .then(api => new Promise<any>(resolve => {
        api.createController(host, {
          uri,
          width: 1,
          height: 1,
        }, (controller: any) => {
          this.spotifyEmbedController = controller;
          controller.addListener('playback_started', () => {
            if (!this.nowPlaying?.embed_mode) return;
            this.nowPlaying.is_playing = true;
            this.musicLiveActivityActive = true;
            this.syncMusicLiveActivity(true);
          });
          controller.addListener('playback_update', (event: any) => {
            if (!this.nowPlaying?.embed_mode) return;
            const state = event?.data || {};
            if (Number.isFinite(state.duration) && state.duration > 0) {
              this.nowPlaying.duration_ms = state.duration;
            }
            if (Number.isFinite(state.position)) {
              this.nowPlaying.progress_ms = state.position;
            }
            this.nowPlaying.is_playing = !state.isPaused && !state.isBuffering;
            if (this.nowPlaying.is_playing) this.musicLiveActivityActive = true;
            if (this.musicLiveActivityActive) this.syncMusicLiveActivity();
            if (
              state.isPaused
              && Number.isFinite(state.duration)
              && state.duration > 0
              && Number(state.position) >= state.duration - 500
            ) {
              void this.refreshAfterTrackEnd(this.nowPlaying?.id || this.nowPlaying?.uri);
            }
          });
          resolve(controller);
        });
      }))
      .catch(error => {
        console.warn('Spotify Embed could not be initialized.', error);
        return null;
      })
      .finally(() => {
        this.spotifyEmbedControllerPromise = undefined;
      });

    return this.spotifyEmbedControllerPromise;
  }

  private async playSpotifyEmbed(song: any): Promise<boolean> {
    const uri = typeof song?.uri === 'string' ? song.uri : '';
    if (!uri) return false;
    const controller = await this.prepareSpotifyEmbed(song);
    if (!controller) return false;

    try {
      // Spotify's current iframe API uses loadUri. Keep loadEntity only as a
      // compatibility fallback for older controller implementations.
      if (typeof controller.loadUri === 'function') {
        controller.loadUri(uri);
      } else if (typeof controller.loadEntity === 'function') {
        controller.loadEntity(uri, false, 0);
      } else {
        throw new Error('Spotify iframe controller has no supported load method');
      }

      this.stopPreviewPlayback();
      this.clearProgressTimer();
      this.nowPlaying = {
        ...song,
        embed_mode: true,
        preview_mode: true,
        is_playing: false,
        progress_ms: 0,
      };
      controller.play?.();
      return true;
    } catch (error) {
      console.error('Spotify iframe playback failed.', error);
      this.pauseSpotifyEmbed();
      return false;
    }
  }

  private pauseSpotifyEmbed(): void {
    this.spotifyEmbedController?.pause?.();
    if (this.nowPlaying?.embed_mode) {
      this.nowPlaying.is_playing = false;
      if (this.musicLiveActivityActive) this.syncMusicLiveActivity(true);
    }
  }

  private destroySpotifyEmbed(): void {
    this.spotifyEmbedController?.destroy?.();
    this.spotifyEmbedController = undefined;
    this.spotifyEmbedControllerPromise = undefined;
  }

  private buildSpotifyLoginUrl(): string {
    const userId = this.formservice.profile?.id ?? this.formservice.profile?.user_id;
    if (userId === undefined || userId === null || String(userId).trim() === '') return '';

    const scopes = [
      'user-read-email',
      'user-read-private',
      'user-read-playback-state',
      'user-modify-playback-state',
      'user-read-currently-playing',
      'user-read-recently-played',
      'user-top-read',
      'playlist-read-private',
      'playlist-modify-public',
      'playlist-modify-private',
      'streaming',
      'app-remote-control',
    ].join(' ');
    const params = new URLSearchParams({
      response_type: 'code',
      client_id: '9253a3d821874dc09c43a1f8168ffc1f',
      redirect_uri: 'https://9jkrdd2hdl.execute-api.us-east-1.amazonaws.com/login/holistic_spotify_/callback',
      scope: scopes,
      state: String(userId),
      show_dialog: 'true',
    });
    return `https://accounts.spotify.com/authorize?${params.toString()}`;
  }

  private async requestSpotifyLoginUrlAndPrompt(previewPlaying = false): Promise<void> {
    try {
      const raw = await this.request.createRequestPost('spotify_search_auth', {
        oauth_log_in: true,
        return_login_url: true,
      });
      const data = this.parseSpotifyAuthResponse(raw);
      if (typeof data?.login === 'string' && data.login.trim()) {
        await this.showSpotifyLoginPrompt(data.login, previewPlaying);
        return;
      }
      const fallbackLoginUrl = this.buildSpotifyLoginUrl();
      if (fallbackLoginUrl) await this.showSpotifyLoginPrompt(fallbackLoginUrl, previewPlaying);
    } catch (error) {
      console.warn('Unable to request Spotify login URL', error);
      const fallbackLoginUrl = this.buildSpotifyLoginUrl();
      if (fallbackLoginUrl) await this.showSpotifyLoginPrompt(fallbackLoginUrl, previewPlaying);
    }
  }

  private ensureSpotifySession(): Promise<boolean> {
    if (this.spotifySessionConfirmed) return Promise.resolve(true);
    if (this.spotifySessionCheck) return this.spotifySessionCheck;

    this.spotifySessionCheck = this.request
      .createRequestPost('spotify_search_auth', { oauth_log_in: true })
      .then(async raw => {
        const data = this.parseSpotifyAuthResponse(raw);
        if (data?.login) {
          await this.showSpotifyLoginPrompt(data.login);
          return false;
        }

        // The OAuth endpoint returns Spotify profile/top items for a linked
        // account. Never send a player command for an ambiguous response.
        if (Array.isArray(data?.items)) {
          this.spotifySessionConfirmed = true;
          return true;
        }

        await this.requestSpotifyLoginUrlAndPrompt();
        return false;
      })
      .catch(async error => {
        console.warn('Unable to confirm Spotify session', error);
        await this.requestSpotifyLoginUrlAndPrompt();
        return false;
      })
      .finally(() => {
        this.spotifySessionCheck = undefined;
      });

    return this.spotifySessionCheck;
  }

  private async showSpotifyPlaybackFailure(data: any): Promise<void> {
    this.spotifySessionConfirmed = false;
    this.spotifySessionKnown = true;
    if (!this.previewAudio && !this.nowPlaying?.embed_mode) {
      await this.playSpotifyEmbed(this.nowPlaying);
    }
    const previewPlaying = Boolean(
      (this.previewAudio && !this.previewAudio.paused) ||
      (this.nowPlaying?.embed_mode && this.nowPlaying?.is_playing)
    );
    if (data?.login) {
      await this.showSpotifyLoginPrompt(data.login, previewPlaying);
      return;
    }
    await this.requestSpotifyLoginUrlAndPrompt(previewPlaying);
  }

  authenticate(){
    const requestId = ++this.profileRequestId;
    if(!this.formservice.profile){
               Swal2.fire({
          title: 'Log in...',
          text: 'Please log in to access this feature... ',
          icon: 'info',
          timer: 2100, // Show the alert for 45 seconds
          background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
          showConfirmButton: false
          });
    }
    
   console.log('authenticate called')
  this.request.createRequestPost('spotify_search_auth',{oauth_log_in:true, fetch_all:true}).then((data) =>{
     if (requestId !== this.profileRequestId) return;
     console.log('songs',data);
          if (data && typeof data === 'string') {
            try {
              data = JSON.parse(data);
              console.log('getRecordByToken ios:',data);
            } catch (error) {
              console.error("Error parsing data:", error);
            }
            }
         
          if(data?.login){
               
            this.openBrowser(data.login)
          // Call this right after you set this.events (e.g., after the API response)

          }else if(data?.items?.length) {
            this.spotifySessionConfirmed = true;
            this.show_profile_page=true;
            this.user_top_data=data;
            this.syncNativeMusicSearch(true);

          }
        
 }).catch((error)=>{
      console.log(error);
    });
  }
  
  async playsong(song){
    // Start the public preview synchronously from the click. Safari and iOS
    // WebViews revoke the media user gesture if playback waits for an API call.
    const previewStarted = this.playPreview(song);
    const embedAttempt = !previewStarted && this.spotifySessionKnown && !this.spotifySessionConfirmed
      ? this.playSpotifyEmbed(song)
      : Promise.resolve(false);
    const [session, embedStarted] = await Promise.all([
      this.checkSpotifySessionWithoutPrompt(),
      embedAttempt,
    ]);
    if (!session.authenticated) {
      const iframeStarted = embedStarted || (!previewStarted && await this.playSpotifyEmbed(song));
      const fallbackStarted = previewStarted || iframeStarted;
      if (session.loginUrl) {
        await this.showSpotifyLoginPrompt(session.loginUrl, fallbackStarted);
      } else if (!fallbackStarted) {
        await this.requestSpotifyLoginUrlAndPrompt();
      }
      return;
    }

    // An authenticated Spotify session must never continue with the public
    // preview. Device selection and remote playback own the track from here.
    this.stopPreviewPlayback();
    this.pauseSpotifyEmbed();
    const remoteTrack = { ...song };
    delete remoteTrack.embed_mode;
    delete remoteTrack.preview_mode;
    delete remoteTrack.full_duration_ms;
    this.nowPlaying = { ...remoteTrack, is_playing: false, progress_ms: 0 };

        console.log('song', song)
    if(!this.deviceSelectionConfirmed || !this.default_device_id){
    console.log('song', song.uri)
    this.request.createRequestPost('spotify_search_auth',{get_devices:true}).then(async (data) =>{
          if (data && typeof data === 'string') {
            try {
              data = JSON.parse(data);
              console.log('getRecordByToken ios:',data);
            } catch (error) {
              console.error("Error parsing data:", error);
            }
            }
             // 2) Body may be a JSON string – parse it
    let bodyObj: any = data?.body;
    if (typeof bodyObj === 'string') {
      try { bodyObj = JSON.parse(bodyObj); } catch { bodyObj = {}; }
    } else if (typeof bodyObj !== 'object' || bodyObj === null) {
      bodyObj = {};
    }

    // 3) Extract devices and store them
    const devices: any[] = Array.isArray(bodyObj?.devices) ? bodyObj.devices : [];


    if (!devices.length) {
      const sheet = await this.actionSheetController.create({
        header: 'No Spotify devices found',
        subHeader: 'Open Spotify on a device and try again.',
        cssClass: 'lk-music-action-sheet',
        buttons: [
          {
            text: 'Close',
            icon: 'close',
            role: 'cancel',
          },
        ],
      });
      await sheet.present();
      return;
    }

    const sheet = await this.actionSheetController.create({
      header: 'Choose a playback device',
      subHeader: 'Choose a device for this LK Music session.',
      cssClass: 'lk-music-action-sheet',
      buttons: [
        ...devices.filter(device => device?.id).map(device => ({
          text: `${device.name} — ${device.type}${device.is_active ? ' (Spotify active)' : ''}`,
          icon: device.type === 'Computer' ? 'desktop-outline' : 'phone-portrait-outline',
          handler: () => {
            this.default_device_id = device.id;
            this.deviceSelectionConfirmed = true;
            this.play(remoteTrack.uri, true, remoteTrack);
          },
        })),
        {
          text: 'Cancel',
          icon: 'close',
          role: 'cancel',
        },
      ],
    });
    await sheet.present();
          console.log('devices',data);
          
          // Call this right after you set this.events (e.g., after the API response)

 }).catch((error)=>{
      console.log(error);
    });

  }else{
     this.play(song.uri, true, song);
  }
  }
  async play(song_uri, sessionVerified = false, fullTrack?: any){
   if (!sessionVerified && !(await this.ensureSpotifySession())) return;
   const contextUri =
  this.current_playlist?.id
    ? `spotify:playlist:${this.current_playlist.id}`
    : (this.nowPlaying?.album?.uri || this.nowPlaying?.context_uri || null);


      this.request.createRequestPost('spotify_search_auth',{context_uri:contextUri,toggle_play:true, device_identification:this.default_device_id, song_uri:song_uri}).then((data) =>{
          data = this.parseSpotifyAuthResponse(data);
          console.log('songs',data);
          if (data?.ok !== true) {
            this.clearProgressTimer();
            if (this.nowPlaying && !this.previewAudio) {
              this.nowPlaying.is_playing = false;
              if (this.musicLiveActivityActive) this.syncMusicLiveActivity(true);
            }
            this.showSpotifyPlaybackFailure(data);
            return;
          }

          // Spotify returned HTTP 204 through the backend (`ok: true`).
          // Only now may the UI represent active playback.
          this.spotifySessionConfirmed = true;
          this.spotifySessionKnown = true;
          this.stopPreviewPlayback(false);
          this.pauseSpotifyEmbed();
          if (fullTrack) {
            this.nowPlaying = {
              ...fullTrack,
              is_playing: true,
              progress_ms: 0,
            };
          }
          this.nowPlaying.is_playing = true;
          this.recordPlayedSong(this.nowPlaying);
          this.startProgressTimer();
 }).catch((error)=>{
      console.log(error);
      this.clearProgressTimer();
      if (this.nowPlaying && !this.previewAudio) this.nowPlaying.is_playing = false;
      this.spotifySessionConfirmed = false;
      this.spotifySessionKnown = true;
      this.requestSpotifyLoginUrlAndPrompt();
    });
  }
   onSearchChange(event: any) {
    this.showHistory = false;
    this.show_playlists=false;
   
   const searchTerm = event.detail.value;
    this.searchTerm=searchTerm;
      this.index=0;
      this.loadTracks(searchTerm);
      this.syncNativeMusicSearch(true);
   }
  change_title(tab){
        this.showHistory = false;
        if (tab !== 'profile') {
          // Invalidate an in-flight profile request so a late response cannot
          // force the Top Artists view back over the selected destination.
          this.profileRequestId++;
        }
        this.show_profile_page=false;
       setTimeout(() => this.syncNativeMusicSearch(true), 0);
       if(tab==='Whisper'){
   
             this.router.navigate(['/home/messages-page']);
   
      
       }else if(tab==='profile'){
   
           this.authenticate();
   
   
       
       
       }else if(tab==='Laniakea'){
         this.router.navigate(['/home/ecosystem-page']);
     
       
         
       }else if(tab=='crear'){
         if(!this.formservice.profile){
           Swal2.fire({
             title: 'You must sign in',
             text: `Ve a https://supercumulo.laniakea.tv/login`,
             icon: 'error',
             timer: 6900,
             timerProgressBar: true,
             toast: true,
             position: 'top-start',
             showConfirmButton: false,
             background: '#010f4e',
           });
           return;
         }
         try{
           this.NewPublication.presentActionSheet();
         }catch{
           Swal2.fire({
             title: 'You must sign in',
             text: `Ve a https://supercumulo.laniakea.tv/login`,
             icon: 'error',
             timer: 6900,
             timerProgressBar: true,
             toast: true,
             position: 'top-start',
             showConfirmButton: false,
             background: '#010f4e',
           });
         }
        
       }
   

     }

     navigateHome(): void {
      this.router.navigateByUrl('/home');
     }

     async openBrowser(url){
      const targetUrl = typeof url === 'string' ? url.trim() : '';
      if (!targetUrl) return;

      // Spotify's authorization pages explicitly refuse iframe embedding.
      // Open them directly so the user never lands on a broken inline frame.
      let isSpotifyAuthorization = false;
      try {
        const parsedUrl = new URL(targetUrl);
        isSpotifyAuthorization =
          parsedUrl.hostname === 'accounts.spotify.com' ||
          parsedUrl.pathname.includes('/login/spotify') ||
          parsedUrl.pathname.includes('/login/holistic_spotify_');
      } catch {
        isSpotifyAuthorization = targetUrl.includes('spotify');
      }

      if(Capacitor.getPlatform() !== 'web' || isSpotifyAuthorization){
        await Browser.open({ url: targetUrl });
      }else{
        const modal = await this.modalController.create({
              canDismiss: true, // (forced globally for swipe close on all modals)
              component: InlineBowsingComponent,
              componentProps: {
                url: targetUrl,
                externalBrowserFallback: true,
              },
              });
        modal.onDidDismiss().then((data)=>{

        });
        return await modal.present();
      }
    }



show_playlists;
          fetchPlaylists() {
            // The first library button represents Songs/Albums. It must always
            // exit the profile view before toggling the library content.
            this.profileRequestId++;
            this.show_profile_page = false;
            setTimeout(() => this.syncNativeMusicSearch(true), 0);

            if(!this.show_playlists){
            this.show_playlists=true;
  this.startPageLoading();
  this.request.createRequestPost('spotify_search_auth', { get_playlists: true })
    .then((data: any) => {
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch { /* ignore */ }
      }

      // Parse the body (server returns it as a JSON string)
      let bodyObj: any = data?.body;
      if (typeof bodyObj === 'string') {
        try { bodyObj = JSON.parse(bodyObj); } catch { bodyObj = {}; }
      }
      if (!bodyObj || typeof bodyObj !== 'object') bodyObj = {};

      const items: any[] = Array.isArray(bodyObj.items) ? bodyObj.items : [];

      // Map to UI-friendly shape (no functions needed in the template)
      this.playlists = items.map(p => ({
        id: p?.id ?? null,
        name: p?.name ?? '',
        ownerName: p?.owner?.display_name ?? '',
        externalUrl: p?.external_urls?.spotify ?? '',
        tracksTotal: p?.tracks?.total ?? 0,
        imageUrl: (p?.images?.[0]?.url || p?.images?.[1]?.url || p?.images?.[2]?.url || ''), // best available
        public: !!p?.public,
        uri: p?.uri ?? null,
      }));

      this.chunkedPlaylists = this.chunk4(this.playlists);

      // keep pagination if you want to fetch more later
      this.playlistsNext = bodyObj.next ?? null;
      this.playlistsPrev = bodyObj.previous ?? null;

      console.log('playlists:', this.playlists);
      console.log('chunkedPlaylists (4 per slide):', this.chunkedPlaylists);
    })
    .catch((error: any) => {
      console.error('fetchPlaylists error', error);
      Swal2.fire('Error', 'Failed to retrieve playlists.', 'error');
    }).finally(() => {
      this.finishPageLoading();
      this.bindWheelToAllSlides();
    });
                  
            }else{
              this.show_playlists=false;
            }
}

private chunk4(arr: any[]): any[][] {
  const out: any[][] = [];
  for (let i = 0; i < arr.length; i += 4) out.push(arr.slice(i, i + 4));
  return out;
}
async add_to_queue(song){
  if (!(await this.ensureSpotifySession())) return;

  console.log('add_to_queue called',  song.uri)
    this.request.createRequestPost('spotify_search_auth', { add_to_queue: true, song_uri:  song.uri })
    .then((data: any) => {
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch { /* ignore */ }
      }
      if(data.ok){
         Swal2.fire({
                title: 'added to queue',
                icon: 'success',
                toast: true,
                confirmButtonText: 'Understood',
                color: '#ffffff',
                background: '#010f4e',
              timer: 3900, // Show the alert for 6.9 seconds
                position: 'bottom-start',
              });
      }
       })
    .catch((error: any) => {
      console.error('fetchPlaylists error', error);
      Swal2.fire('Error', 'Failed to add to queue.', 'error');
    });

}

async handleSongLibraryAction(song: any): Promise<void> {
  if (this.profilePlaylistTargetId) {
    try {
    const raw = await this.request.createRequestPost('profile_music_playlist_auth', {
      profile_id: this.profilePlaylistTargetId,
      track: song,
    });
    let data: any = raw;
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch { data = {}; }
    }
    if (!Array.isArray(data?.tracks)) throw new Error('Invalid playlist response');

    await Swal2.fire({
      title: 'Added to profile playlist',
      text: `${song?.name || 'Song'} is now visible on your profile.`,
      icon: 'success',
      toast: true,
      position: 'top',
      timer: 2600,
      showConfirmButton: false,
      color: '#ffffff',
      background: '#010f4e',
    });
    } catch (error) {
    console.error('Unable to add track to profile playlist.', error);
    await Swal2.fire({
      title: 'Could not add song',
      text: 'Please confirm that this is your profile and try again.',
      icon: 'error',
      confirmButtonText: 'OK',
      color: '#ffffff',
      background: '#010f4e',
    });
    }
    return;
  }

  const sheet = await this.actionSheetController.create({
    header: song?.name || 'Song options',
    subHeader: 'Where would you like to add this song?',
    cssClass: 'lk-music-action-sheet',
    buttons: [
      {
        text: 'Add to Spotify playlist',
        icon: 'logo-spotify',
        handler: () => void this.chooseSpotifyPlaylist(song),
      },
      {
        text: 'Add to Spotify queue',
        icon: 'list-outline',
        handler: () => void this.add_to_queue(song),
      },
      { text: 'Cancel', icon: 'close', role: 'cancel' },
    ],
  });
  await sheet.present();
}

async chooseSpotifyPlaylist(song: any): Promise<void> {
  if (!(await this.ensureSpotifySession())) return;

  try {
    let data: any = await this.request.createRequestPost('spotify_search_auth', {
      get_playlists: true,
      limit: 50,
    });
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch { data = {}; }
    }
    let body: any = data?.body ?? data;
    if (typeof body === 'string') {
      try { body = JSON.parse(body); } catch { body = {}; }
    }
    const playlists = (Array.isArray(body?.items) ? body.items : [])
      .filter((playlist: any) => playlist?.id && playlist?.name);

    if (!playlists.length) {
      await Swal2.fire({
        title: 'No Spotify playlists found',
        text: 'Create a playlist in Spotify first, then try again.',
        icon: 'info',
      });
      return;
    }

    const picker = await this.actionSheetController.create({
      header: 'Add to Spotify playlist',
      subHeader: song?.name || '',
      cssClass: 'lk-music-action-sheet',
      buttons: [
        ...playlists.map((playlist: any) => ({
          text: playlist.name,
          icon: playlist.public === false ? 'lock-closed-outline' : 'musical-notes-outline',
          handler: () => void this.addSongToSpotifyPlaylist(song, playlist),
        })),
        { text: 'Cancel', icon: 'close', role: 'cancel' },
      ],
    });
    await picker.present();
  } catch (error) {
    console.error('Unable to load Spotify playlists.', error);
    await Swal2.fire({
      title: 'Could not load Spotify playlists',
      text: 'Please try again.',
      icon: 'error',
    });
  }
}

private async addSongToSpotifyPlaylist(song: any, playlist: any): Promise<void> {
  try {
    let data: any = await this.request.createRequestPost('spotify_search_auth', {
      add_to_playlist: true,
      playlist_id: playlist.id,
      song_uri: song?.uri,
    });
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch { data = {}; }
    }

    if (data?.already_exists) {
      if (song?.uri) this.spotifyPlaylistSongUris.add(song.uri);
      await Swal2.fire({
        title: 'Already in playlist',
        text: `${song?.name || 'Song'} is already in ${playlist?.name || 'this playlist'}.`,
        icon: 'info',
        toast: true,
        position: 'bottom-start',
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }

    if (!data?.ok) {
      const message = data?.error?.message || data?.message || 'Spotify rejected the playlist update.';
      if (Number(data?.status) === 403) {
        this.spotifySessionConfirmed = false;
        await this.requestSpotifyLoginUrlAndPrompt();
        return;
      }
      throw new Error(message);
    }

    if (song?.uri) this.spotifyPlaylistSongUris.add(song.uri);

    await Swal2.fire({
      title: 'Added to Spotify',
      text: `${song?.name || 'Song'} was added to ${playlist?.name || 'your playlist'}.`,
      icon: 'success',
      toast: true,
      position: 'bottom-start',
      timer: 3000,
      showConfirmButton: false,
    });
  } catch (error: any) {
    console.error('Unable to add song to Spotify playlist.', error);
    if (Number(error?.status) === 401 || Number(error?.status) === 403) {
      this.spotifySessionConfirmed = false;
      await this.requestSpotifyLoginUrlAndPrompt();
      return;
    }
    await Swal2.fire({
      title: 'Could not add the song',
      text: error?.message || 'Please try again.',
      icon: 'error',
    });
  }
}
private progressTimer: any = null;
private clearProgressTimer() {
  if (this.progressTimer) {
    clearInterval(this.progressTimer);
    this.progressTimer = null;
  }
}

private startProgressTimer() {
  this.clearProgressTimer();
  if (!this.nowPlaying?.is_playing) return;
  this.musicLiveActivityActive = true;
  this.syncMusicLiveActivity();
  if (!this.nowPlaying?.duration_ms) return;

  let lastTick = Date.now();
  this.progressTimer = setInterval(() => {
    if (!this.nowPlaying?.is_playing) {
      this.clearProgressTimer();
      return;
    }

    const now = Date.now();
    const elapsed = Math.max(0, now - lastTick);
    lastTick = now;
    const dur  = this.nowPlaying.duration_ms || 0;
    const cur  = this.nowPlaying.progress_ms || 0;
    const next = Math.min(dur, cur + elapsed);
    this.nowPlaying.progress_ms = next;

    if (next >= dur) {
      this.clearProgressTimer();
      void this.refreshAfterTrackEnd(this.nowPlaying?.id || this.nowPlaying?.uri);
    }
  }, 500);
}

private syncMusicLiveActivity(force = false): void {
  if (Capacitor.getPlatform() !== 'ios' || !this.musicLiveActivityActive || !this.nowPlaying) return;

  const trackId = String(this.nowPlaying.id || this.nowPlaying.uri || this.nowPlaying.name || 'current-track');
  const isPlaying = Boolean(this.nowPlaying.is_playing);
  const now = Date.now();
  const trackChanged = trackId !== this.musicLiveActivityLastTrackId;
  const playbackChanged = isPlaying !== this.musicLiveActivityLastIsPlaying;
  if (!force && !trackChanged && !playbackChanged && now - this.musicLiveActivityLastSentAt < 15000) return;

  const rawDurationMs = Number(this.nowPlaying.duration_ms);
  const durationMs = Number.isFinite(rawDurationMs) ? Math.max(0, rawDurationMs) : 0;
  const rawProgressMs = Number(this.nowPlaying.progress_ms);
  const progressMs = Math.min(durationMs, Number.isFinite(rawProgressMs) ? Math.max(0, rawProgressMs) : 0);
  const title = String(this.nowPlaying.name || 'Now Playing').trim().slice(0, 120) || 'Now Playing';
  const artist = (this.nowPlaying.artists || [])
    .map((item: any) => String(item?.name || '').trim())
    .filter(Boolean)
    .join(', ')
    .slice(0, 160);
  const progress = durationMs > 0 ? progressMs / durationMs : 0;

  this.musicLiveActivityLastSentAt = now;
  this.musicLiveActivityLastTrackId = trackId;
  this.musicLiveActivityLastIsPlaying = isPlaying;
  this.musicLiveActivityOperation = this.musicLiveActivityOperation
    .catch(() => undefined)
    .then(async () => {
      if (!this.musicLiveActivityActive) return;
      const { available } = await NativeLiveActivities.isAvailable();
      if (!available || !this.musicLiveActivityActive) return;
      await NativeLiveActivities.upsert({
        id: 'lk-music-playback',
        kind: 'music',
        title: 'LK Music',
        status: isPlaying ? 'Playing' : 'Paused',
        detail: title,
        subtitle: artist,
        progress,
        durationSeconds: durationMs / 1000,
        isPlaying,
        destination: 'https://laniakea.tv/lk-music',
      });
    })
    .catch(error => console.warn('LK Music Live Activity could not update.', error));
}

private endMusicLiveActivity(): void {
  if (Capacitor.getPlatform() !== 'ios') return;
  this.musicLiveActivityActive = false;
  this.musicLiveActivityLastSentAt = 0;
  this.musicLiveActivityLastTrackId = '';
  this.musicLiveActivityLastIsPlaying = undefined;
  this.musicLiveActivityOperation = this.musicLiveActivityOperation
    .catch(() => undefined)
    .then(async () => {
      if (this.musicLiveActivityActive) return;
      await NativeLiveActivities.end({ id: 'lk-music-playback' });
    })
    .catch(error => console.warn('LK Music Live Activity could not end.', error));
}

private async refreshAfterTrackEnd(endedTrackId?: string): Promise<void> {
  if (this.trackEndRefreshInProgress || !this.viewActive) return;

  this.trackEndRefreshInProgress = true;
  const generation = ++this.trackEndRefreshGeneration;
  const endedId = String(endedTrackId || '');

  try {
    // Spotify can expose the ended item for a moment before advancing its
    // playback state. Retry quietly until a different item (or reset progress)
    // becomes authoritative.
    for (const delay of [250, 500, 900, 1500, 2500, 4000]) {
      await new Promise(resolve => setTimeout(resolve, delay));
      if (!this.viewActive || generation !== this.trackEndRefreshGeneration) return;

      const refreshed = await this.fetchNowPlaying(false);
      const currentId = String(this.nowPlaying?.id || this.nowPlaying?.uri || '');
      const progress = Number(this.nowPlaying?.progress_ms) || 0;
      const duration = Number(this.nowPlaying?.duration_ms) || 0;
      if (refreshed && (currentId !== endedId || progress < Math.max(1000, duration - 1500))) {
        return;
      }
    }
  } finally {
    if (generation === this.trackEndRefreshGeneration) {
      this.trackEndRefreshInProgress = false;
    }
  }
}

previewSeek(event: Event): void {
  const input = event.target as HTMLInputElement | null;
  if (!input || !this.nowPlaying) return;
  this.nowPlaying.progress_ms = Number(input.value) || 0;
}

async seekToValue(event: Event): Promise<void> {
  const input = event.target as HTMLInputElement | null;
  if (!input || !this.nowPlaying?.duration_ms) return;
  await this.seekToPosition(Number(input.value) || 0);
}

private async seekToPosition(requestedPositionMs: number): Promise<void> {
  if (!this.nowPlaying?.duration_ms) return;

  const wasPlaying = Boolean(this.nowPlaying.is_playing);
  const positionMs = Math.max(
    0,
    Math.min(this.nowPlaying.duration_ms, requestedPositionMs),
  );
  this.nowPlaying.progress_ms = positionMs;
  if (this.musicLiveActivityActive) this.syncMusicLiveActivity(true);

  // Preview audio can be repositioned whether it is playing or paused.
  if (this.nowPlaying?.preview_mode && this.previewAudio) {
    this.previewAudio.currentTime = positionMs / 1000;
    return;
  }

  // Spotify's iframe controller also supports seeking while paused.
  if (this.nowPlaying?.embed_mode && this.spotifyEmbedController) {
    this.spotifyEmbedController.seek(positionMs / 1000);
    return;
  }

  if (!(await this.ensureSpotifySession())) return;

  try {
    let data: any = await this.request.createRequestPost('spotify_search_auth', {
      player: true,
      seek_song: true,
      position_ms: Math.round(positionMs),
      device_identification: this.default_device_id,
    });
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch {}
    }
    if (!data?.ok) throw new Error(data?.message || data?.stage || 'Spotify seek failed');
    if (wasPlaying) {
      this.nowPlaying.is_playing = true;
      this.startProgressTimer();
    }
  } catch (error) {
    console.error('Unable to seek Spotify playback.', error);
    Swal2.fire({
      title: 'Could not change song position',
      icon: 'error',
      timer: 2200,
    });
  }
}

async togglePlay(){
if (this.nowPlaying?.embed_mode && this.spotifyEmbedController) {
  if (this.nowPlaying.is_playing) {
    this.pauseSpotifyEmbed();
    return;
  }

  this.spotifyEmbedController.resume();
  const session = await this.checkSpotifySessionWithoutPrompt();
  if (session.authenticated) {
    const song = { ...this.nowPlaying };
    delete song.embed_mode;
    delete song.preview_mode;
    this.pauseSpotifyEmbed();
    this.nowPlaying = { ...song, is_playing: false, progress_ms: 0 };
    this.play(song.uri, true, song);
  } else if (session.loginUrl) {
    await this.showSpotifyLoginPrompt(session.loginUrl, true);
  }
  return;
}

if (this.nowPlaying?.preview_mode && this.previewAudio) {
  if (this.previewAudio.paused) {
    await this.previewAudio.play().catch(() => undefined);
    const session = await this.checkSpotifySessionWithoutPrompt();
    if (session.authenticated) {
      const song = { ...this.nowPlaying, duration_ms: this.nowPlaying.full_duration_ms };
      delete song.preview_mode;
      delete song.full_duration_ms;
      this.stopPreviewPlayback();
      this.nowPlaying = song;
      this.play(song.uri, true);
    } else if (session.loginUrl) {
      await this.showSpotifyLoginPrompt(session.loginUrl, Boolean(this.previewAudio && !this.previewAudio.paused));
    }
  } else {
    this.previewAudio.pause();
  }
  return;
}

const session = await this.checkSpotifySessionWithoutPrompt();
if (!session.authenticated) {
  const previewStarted = this.playPreview(this.nowPlaying);
  if (session.loginUrl) {
    await this.showSpotifyLoginPrompt(session.loginUrl);
  } else if (!previewStarted) {
    await this.requestSpotifyLoginUrlAndPrompt();
  }
  return;
}

if (this.nowPlaying?.is_playing){
  this.request.createRequestPost('spotify_search_auth',{player:true,stop_song:true, device_identification:this.default_device_id}).then((data) =>{
          if (data && typeof data === 'string') {
            try {
              data = JSON.parse(data);
              console.log('getRecordByToken ios:',data);
            } catch (error) {
              console.error("Error parsing data:", error);
            }
            }
          console.log('songs',data);
          // Call this right after you set this.events (e.g., after the API response)
    // Give Spotify a moment to switch/queue, then fetch state and start progress
            this.clearProgressTimer();
      this.nowPlaying.is_playing=false ;
      if (this.musicLiveActivityActive) this.syncMusicLiveActivity(true);
 }).catch((error)=>{
      console.log(error);
    });
}else{
  this.play(this.nowPlaying.uri, true);

}
}
async player(type){
  if (!(await this.ensureSpotifySession())) return;
  let query;
  if(type=='previous_song'){
	await this.changeSpotifyTrack('previous_song');
  }else if (type=='next_song'){
	await this.changeSpotifyTrack('next_song');
  }else if(type=='toggle_shuffle'){
try {
let data: any = await this.request.createRequestPost('spotify_search_auth',{player:true,toggle_shuffle:true,type:true});
          if (data && typeof data === 'string') {
            try {
              data = JSON.parse(data);
              console.log('getRecordByToken ios:',data);

            } catch (error) {
              console.error("Error parsing data:", error);
            }
            }

          console.log('songs',data);
          if (data?.ok !== true || typeof data?.shuffle_state !== 'boolean') {
            throw new Error(data?.message || 'Spotify did not confirm shuffle.');
          }
          this.pendingShuffleState = data.shuffle_state;
          this.pendingShuffleExpiresAt = Date.now() + 30000;
          this.nowPlaying.shuffle_state = data.shuffle_state;
          await this.confirmSpotifyPlaybackModes();
 } catch (error) {
      this.pendingShuffleState = undefined;
      this.pendingShuffleExpiresAt = 0;
      console.log(error);
      await this.fetchNowPlaying(false);
 }
  }else if(type=='toggle_repeat'){
    try {
    let data: any = await this.request.createRequestPost('spotify_search_auth',{player:true,toggle_repeat:true,type:true});
          if (data && typeof data === 'string') {
            try {
              data = JSON.parse(data);
              console.log('getRecordByToken ios:',data);

            } catch (error) {
              console.error("Error parsing data:", error);
            }
            }

          console.log('songs',data);
          if (data?.ok !== true || !['off', 'context', 'track'].includes(data?.repeat_state)) {
            throw new Error(data?.message || 'Spotify did not confirm repeat mode.');
          }
          this.pendingRepeatState = data.repeat_state;
          this.pendingRepeatExpiresAt = Date.now() + 30000;
          this.nowPlaying.repeat_state = data.repeat_state;
          await this.confirmSpotifyPlaybackModes();
    } catch (error) {
      this.pendingRepeatState = undefined;
      this.pendingRepeatExpiresAt = 0;
      console.log(error);
      await this.fetchNowPlaying(false);
    }
  }

}

private async confirmSpotifyPlaybackModes(): Promise<void> {
  // Spotify Connect state is eventually consistent. Keep the acknowledged
  // toggle visible while older player snapshots drain, then accept the first
  // snapshot that confirms the requested mode.
  for (const delay of [300, 700, 1500, 3000, 5000]) {
    await new Promise(resolve => setTimeout(resolve, delay));
    await this.fetchNowPlaying(false, false);
    if (this.pendingShuffleState === undefined && this.pendingRepeatState === undefined) return;
  }
}

private async changeSpotifyTrack(direction: 'previous_song' | 'next_song'): Promise<void> {
  try {
    let data: any = await this.request.createRequestPost('spotify_search_auth', {
      player: true,
      [direction]: true,
      type: true,
    });
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch {}
    }

    // Apply an immediate response when available, then ask Spotify for its
    // authoritative state because skip responses can arrive before playback
    // has switched to the new track.
    const immediate = data?.now_playing;
    if (immediate?.item) {
      this.nowPlaying = {
        ...immediate.item,
        progress_ms: Number(immediate.progress_ms) || 0,
        is_playing: immediate.is_playing !== false,
        shuffle_state: Boolean(immediate.shuffle_state),
        repeat_state: immediate.repeat_state || 'off',
      };
    }

    for (const delay of [250, 500, 900]) {
      await new Promise(resolve => setTimeout(resolve, delay));
      if (await this.fetchNowPlaying(false)) return;
    }
  } catch (error) {
    console.error(`Unable to change Spotify track (${direction}).`, error);
    await this.fetchNowPlaying();
  }
}

async fetchNowPlaying(showFeedback = true, showLoading = showFeedback): Promise<boolean> {
  if (this.nowPlayingRequestInFlight || !(await this.ensureSpotifySession())) return false;

  this.nowPlayingRequestInFlight = true;
  if (showLoading) this.nowPlayingLoading = true;
  try {
    let data: any = await this.request.createRequestPost('spotify_search_auth', {
      player: true,
      current_song: true,
    });

    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch {}
    }

    const current = data?.now_playing ?? data;
    if (!current?.ok || !current?.item) {
      const noPlayback = Number(current?.status) === 204 || current?.message === 'no_content';
      if (noPlayback && this.musicLiveActivityActive) this.endMusicLiveActivity();
      if (showFeedback) {
        Swal2.fire({
          title: noPlayback ? 'Nothing is playing' : 'Could not fetch Spotify',
          text: noPlayback ? 'Start a song in Spotify and try again.' : 'Please try again.',
          icon: noPlayback ? 'info' : 'error',
          timer: 2600,
        });
      }
      return false;
    }

    this.stopPreviewPlayback(false);
    if (this.pendingShuffleState !== undefined && Date.now() >= this.pendingShuffleExpiresAt) {
      this.pendingShuffleState = undefined;
      this.pendingShuffleExpiresAt = 0;
    }
    if (this.pendingRepeatState !== undefined && Date.now() >= this.pendingRepeatExpiresAt) {
      this.pendingRepeatState = undefined;
      this.pendingRepeatExpiresAt = 0;
    }

    const spotifyShuffleState = Boolean(current.shuffle_state);
    const spotifyRepeatState = ['off', 'context', 'track'].includes(current.repeat_state)
      ? current.repeat_state as 'off' | 'context' | 'track'
      : 'off';
    const displayedShuffleState = this.pendingShuffleState === undefined
      ? spotifyShuffleState
      : this.pendingShuffleState;
    const displayedRepeatState = this.pendingRepeatState === undefined
      ? spotifyRepeatState
      : this.pendingRepeatState;

    if (this.pendingShuffleState === spotifyShuffleState) {
      this.pendingShuffleState = undefined;
      this.pendingShuffleExpiresAt = 0;
    }
    if (this.pendingRepeatState === spotifyRepeatState) {
      this.pendingRepeatState = undefined;
      this.pendingRepeatExpiresAt = 0;
    }

    this.nowPlaying = {
      ...current.item,
      progress_ms: Number(current.progress_ms) || 0,
      is_playing: Boolean(current.is_playing),
      shuffle_state: displayedShuffleState,
      repeat_state: displayedRepeatState,
      device: current.device,
    };
    const activeDevice = current?.device;
    this.spotifyVolumeSupported = Boolean(activeDevice?.supports_volume) && !Boolean(activeDevice?.is_restricted);
    this.spotifyVolumeRestricted = Boolean(activeDevice?.is_restricted);
    if (Number.isFinite(Number(activeDevice?.volume_percent))) {
      this.spotifyVolume = this.clampSpotifyVolume(activeDevice.volume_percent);
    }
    this.recordPlayedSong(this.nowPlaying);

    if (this.nowPlaying.is_playing) this.startProgressTimer();
    else {
      this.clearProgressTimer();
      if (this.musicLiveActivityActive) this.syncMusicLiveActivity(true);
    }
    return true;
  } catch (error) {
    console.error('Unable to fetch Spotify now playing.', error);
    if (showFeedback) {
      Swal2.fire({
        title: 'Could not fetch Spotify',
        text: 'Please try again.',
        icon: 'error',
        timer: 2600,
      });
    }
    return false;
  } finally {
    this.nowPlayingRequestInFlight = false;
    if (showLoading) this.nowPlayingLoading = false;
  }
}

previewSpotifyVolume(event: Event): void {
  this.spotifyVolume = this.clampSpotifyVolume((event.target as HTMLInputElement)?.value);
}

async setSpotifyVolume(eventOrValue: Event | number): Promise<void> {
  if (this.spotifyVolumeLoading) return;
  const rawValue = typeof eventOrValue === 'number'
    ? eventOrValue
    : (eventOrValue.target as HTMLInputElement)?.value;
  const volumePercent = this.clampSpotifyVolume(rawValue);
  this.spotifyVolume = volumePercent;
  this.spotifyVolumeLoading = true;
  try {
    let data: any = await this.request.createRequestPost('spotify_search_auth', {
      player: true,
      set_volume: true,
      volume_percent: volumePercent,
      device_identification: this.default_device_id || this.nowPlaying?.device?.id || undefined,
    });
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch {}
    }
    if (data?.ok !== true) {
      throw new Error(data?.message || 'Spotify did not confirm the volume change.');
    }
  } catch (error) {
    console.error('Unable to set Spotify volume.', error);
    Swal2.fire({
      title: 'Could not change volume',
      text: 'Spotify rejected remote volume control for the active device.',
      icon: 'error',
      timer: 2600,
    });
    await this.fetchNowPlaying(false, false);
  } finally {
    this.spotifyVolumeLoading = false;
  }
}

private clampSpotifyVolume(value: unknown): number {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return 50;
  return Math.min(100, Math.max(0, Math.round(numericValue)));
}

async changeSpotifyPlaybackDevice(): Promise<void> {
  if (this.spotifyDeviceLoading || !(await this.ensureSpotifySession())) return;

  this.spotifyDeviceLoading = true;
  try {
    let data: any = await this.request.createRequestPost('spotify_search_auth', {
      get_devices: true,
    });
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch {}
    }

    let body: any = data?.body ?? data;
    if (typeof body === 'string') {
      try { body = JSON.parse(body); } catch { body = {}; }
    }
    const devices: any[] = Array.isArray(body?.devices) ? body.devices : [];

    if (!devices.length) {
      const emptySheet = await this.actionSheetController.create({
        header: 'No Spotify devices found',
        subHeader: 'Open Spotify on the destination device and try again.',
        cssClass: 'lk-music-action-sheet',
        buttons: [{ text: 'Close', icon: 'close', role: 'cancel' }],
      });
      await emptySheet.present();
      return;
    }

    const sheet = await this.actionSheetController.create({
      header: 'Play on another device',
      subHeader: 'Your current song and position will move to the selected device.',
      cssClass: 'lk-music-action-sheet',
      buttons: [
        ...devices.filter(device => device?.id).map(device => ({
          text: `${device.name} — ${device.type}${device.is_active ? ' (current)' : ''}`,
          icon: device.type === 'Computer' ? 'desktop-outline' : 'phone-portrait-outline',
          handler: () => {
            if (device.is_active) {
              this.default_device_id = device.id;
              this.deviceSelectionConfirmed = true;
              return;
            }
            void this.transferSpotifyPlayback(device.id);
          },
        })),
        { text: 'Cancel', icon: 'close', role: 'cancel' },
      ],
    });
    await sheet.present();
  } catch (error) {
    console.error('Unable to fetch Spotify devices.', error);
  } finally {
    this.spotifyDeviceLoading = false;
  }
}

private async transferSpotifyPlayback(deviceId: string): Promise<void> {
  if (!deviceId) return;
  this.spotifyDeviceLoading = true;
  try {
    let data: any = await this.request.createRequestPost('spotify_search_auth', {
      player: true,
      transfer_device: true,
      device_identification: deviceId,
      play: Boolean(this.nowPlaying?.is_playing),
    });
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch {}
    }
    if (!data?.ok) {
      // Spotify rejects transfer when there is no active remote playback
      // session, even when the destination device itself is valid. In that
      // state, start the selected LK Music track directly on that device.
      this.default_device_id = deviceId;
      this.deviceSelectionConfirmed = true;
      if (this.nowPlaying?.uri) {
        const track = { ...this.nowPlaying };
        delete track.embed_mode;
        delete track.preview_mode;
        delete track.full_duration_ms;
        this.play(track.uri, true, track);
        return;
      }

      let spotifyMessage = data?.message || data?.stage || 'Spotify transfer failed';
      if (typeof data?.body === 'string') {
        try {
          const body = JSON.parse(data.body);
          spotifyMessage = body?.error?.message || spotifyMessage;
        } catch {}
      }
      throw new Error(spotifyMessage);
    }
    this.default_device_id = deviceId;
    this.deviceSelectionConfirmed = true;
  } catch (error) {
    console.error('Unable to transfer Spotify playback.', error);
    const sheet = await this.actionSheetController.create({
      header: 'Could not change device',
      subHeader: 'Make sure Spotify is open on that device and try again.',
      cssClass: 'lk-music-action-sheet',
      buttons: [{ text: 'Close', icon: 'close', role: 'cancel' }],
    });
    await sheet.present();
  } finally {
    this.spotifyDeviceLoading = false;
  }
}
current_playlist;
get_playlist_songs(pl){
  console.log('pl', pl)
  this.current_playlist=pl;
  this.searchTerm=null;
  this.index=0;
  this.terminalPlaylistPageLoaded = false;
  this.playlistWindowOffset = 0;
  this.startPageLoading();
this.request.createRequestPost('spotify_search_auth',{get_playlist_songs:true,playlistId:pl.id}).then((data) =>{
       
// after you get `data` from the API:
if (typeof data === 'string') {
  try { data = JSON.parse(data); } catch {}
}

// some backends wrap the Spotify payload in data.body (string)
let responseBody: any = data;
if (typeof data?.body === 'string') {
  try { responseBody = JSON.parse(data.body); } catch {}
}
let items: any[] = Array.isArray(responseBody?.items) ? responseBody.items : [];
if (!items?.length && typeof data?.body === 'string') {
  try {
    const body = JSON.parse(data.body);
    items = Array.isArray(body?.items) ? body.items : [];
  } catch {}
}
this.playlistTotal = Number(responseBody?.total ?? data?.total ?? items.length) || 0;

// take only tracks
const tracks = (items || [])
  .map((it: any) => it?.track ?? null)
  .filter((t: any) => t && t.type === 'track');   // keep tracks only

this.songs = tracks;
this.chunked_songs = this.chunk(this.songs, 4);
this.show_playlists = false;

console.log('tracks', this.songs);
console.log('chunked', this.chunked_songs);

 }).catch((error)=>{
      console.log(error);
    }).finally(() => {
      this.finishPageLoading();
      this.bindWheelToAllSlides();
    });
}

async goToLastPlaylistPage(): Promise<void> {
  if (!this.current_playlist?.id || this.playlistLastPageLoading) return;

  this.playlistLastPageLoading = true;
  this.startPageLoading();

  try {
    const pageSize = 4;
    const lastPageOffset = this.playlistTotal > 0
      ? Math.floor((this.playlistTotal - 1) / pageSize) * pageSize
      : 0;
    const windowOffset = Math.max(0, lastPageOffset - pageSize);

    let data: any = await this.request.createRequestPost('spotify_search_auth', {
      get_playlist_songs: true,
      playlistId: this.current_playlist.id,
      last_page: true,
      total: this.playlistTotal || undefined,
      limit: pageSize * 2,
      ui_page_size: pageSize,
      previous_items: pageSize,
      // Supplying the terminal offset also makes the feature work against API
      // versions that do not yet understand the last_page convenience flag.
      offset: windowOffset,
    });

    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch {}
    }

    let responseBody: any = data;
    if (typeof data?.body === 'string') {
      try { responseBody = JSON.parse(data.body); } catch {}
    }

    const items: any[] = Array.isArray(responseBody?.items) ? responseBody.items : [];
    const tracks = items
      .map((item: any) => item?.track ?? null)
      .filter((track: any) => track && track.type === 'track');

    this.playlistTotal = Number(responseBody?.total ?? this.playlistTotal) || tracks.length;
    this.playlistWindowOffset = Number(responseBody?.offset);
    if (!Number.isFinite(this.playlistWindowOffset)) this.playlistWindowOffset = windowOffset;
    this.index = Math.floor(this.playlistWindowOffset / pageSize);
    this.songs = tracks;
    this.chunked_songs = this.chunk(tracks, 4);
    this.show_playlists = false;
    this.terminalPlaylistPageLoaded = true;

    // The response contains the previous four tracks and the final four.
    // Open on the final group while keeping the preceding group available.
    setTimeout(() => {
      const finalGroup = Math.max(0, (this.chunked_songs?.length || 1) - 1);
      this.songSlides?.slideTo(finalGroup, 0);
    });
  } catch (error) {
    console.error('Unable to load the final playlist page.', error);
    Swal2.fire({
      title: 'Could not load the last songs',
      text: 'Please try again.',
      icon: 'error',
      timer: 2600,
    });
  } finally {
    this.playlistLastPageLoading = false;
    this.finishPageLoading();
  }
}

  private startPageLoading() {
    this.clearPageLoadingTimeout();
    this.pageLoading = true;
    this.showPageSkeleton = false;
    this.loaderPhaseTimeout = setTimeout(() => {
      if (this.pageLoading) {
        this.showPageSkeleton = true;
      }
    }, this.loaderPhaseMs);
  }

  private finishPageLoading() {
    this.clearPageLoadingTimeout();
    this.pageLoading = false;
    this.showPageSkeleton = false;
  }

  private clearPageLoadingTimeout() {
    if (this.loaderPhaseTimeout) {
      clearTimeout(this.loaderPhaseTimeout);
      this.loaderPhaseTimeout = undefined;
    }
  }
async handleSlideChange(slidesRef?: IonSlides) {
  if (this._loadingMore) return;

  const activeSlides: any = slidesRef || this.slides;
  if (!activeSlides) return;

  if (this.terminalPlaylistPageLoaded) {
    const isBeginning = await activeSlides.isBeginning();
    if (isBeginning) await this.fetchPreviousPlaylistSongs(activeSlides);
    return;
  }

  const isEnd = await activeSlides.isEnd();
  if (!isEnd) return;

  this._loadingMore = true;
  this._lastFetchAt = Date.now();

  // move to next page only when we really fetch
  this.index++;

  Swal2.fire({
    title: 'Fetching posts',
    icon: 'info',
    timer: 6900,
    timerProgressBar: true,
    toast: true,
    position: 'bottom-start',
    color: 'black',
    background: 'white',
  });

  try {
    const offset = this.index * 20;

    if(this.searchTerm){

    const raw = await this.request.createRequestPost('spotify_search', {
      text: this.searchTerm,
      offset: offset,
    });

    let data = raw;
    if (data && typeof data === 'string') {
      try { data = JSON.parse(data); } catch {}
    }

    // Incoming page
    const incoming: any[] = data?.data?.tracks?.items ?? [];
    if (incoming.length) {
      // Optional de-dupe by track.id
      const seen = new Set((this.songs || []).map((s: any) => s?.id));
      const fresh = incoming.filter((t: any) => t?.id && !seen.has(t.id));

      // 🔹 append (push) instead of replacing
      if (!Array.isArray(this.songs)) this.songs = [];
      this.songs.push(...fresh);

      // rebuild slides (4 per slide)
      this.chunked_songs = this.chunk(this.songs, 4);
    }

    console.log('songs (total)', this.songs?.length, this.songs);
    console.log('chunked', this.chunked_songs?.length, this.chunked_songs);
      
    }else{
      const playlistRaw = await this.request.createRequestPost('spotify_search_auth', {
        get_playlist_songs: true,
        playlistId: this.current_playlist.id,
        offset: offset,
      });

      let playlistData: any = playlistRaw;
      if (typeof playlistData === 'string') {
        try { playlistData = JSON.parse(playlistData); } catch {}
      }

      let responseBody: any = playlistData;
      if (typeof playlistData?.body === 'string') {
        try { responseBody = JSON.parse(playlistData.body); } catch {}
      }
      let items: any[] = Array.isArray(responseBody?.items) ? responseBody.items : [];
      if (!items?.length && typeof playlistData?.body === 'string') {
        try {
          const body = JSON.parse(playlistData.body);
          items = Array.isArray(body?.items) ? body.items : [];
        } catch {}
      }
      this.playlistTotal = Number(responseBody?.total ?? playlistData?.total ?? this.playlistTotal) || this.playlistTotal;

      const tracks: any[] = (items || [])
        .map((it: any) => it?.track ?? null)
        .filter((t: any) => t && t.type === 'track');

      if (!Array.isArray(this.songs)) this.songs = [];
      const seen = new Set((this.songs || []).map((s: any) => s?.id));
      const freshTracks = tracks.filter((t: any) => t?.id && !seen.has(t.id));
      this.songs.push(...freshTracks);

      this.chunked_songs = this.chunk(this.songs, 4);
      this.show_playlists = false;

      console.log('tracks appended', freshTracks.length);
      console.log('songs total', this.songs.length);
      console.log('chunked', this.chunked_songs?.length, this.chunked_songs);

    }
  } catch (error) {
    console.log(error);
  } finally {
    this._loadingMore = false;
    Swal2.close();
  }
        
    
}

private async fetchPreviousPlaylistSongs(activeSlides: IonSlides): Promise<void> {
  if (!this.current_playlist?.id || this._loadingMore || this.playlistWindowOffset <= 0) return;

  this._loadingMore = true;
  const requestLimit = 8;
  const previousOffset = Math.max(0, this.playlistWindowOffset - requestLimit);

  try {
    let data: any = await this.request.createRequestPost('spotify_search_auth', {
      get_playlist_songs: true,
      playlistId: this.current_playlist.id,
      offset: previousOffset,
      limit: requestLimit,
    });

    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch {}
    }

    let responseBody: any = data;
    if (typeof data?.body === 'string') {
      try { responseBody = JSON.parse(data.body); } catch {}
    }

    const incoming = (Array.isArray(responseBody?.items) ? responseBody.items : [])
      .map((item: any) => item?.track ?? null)
      .filter((track: any) => track && track.type === 'track');

    const responseOffset = Number(responseBody?.offset);
    const resolvedOffset = Number.isFinite(responseOffset) ? responseOffset : previousOffset;
    const priorCount = Math.max(0, this.playlistWindowOffset - resolvedOffset);
    // The requested range ends where the current in-memory window begins.
    // Slice by position rather than track id because Spotify playlists may
    // legitimately contain the same track more than once.
    const priorTracks = incoming.slice(0, priorCount);
    if (!priorTracks.length) {
      this.playlistWindowOffset = previousOffset;
      return;
    }

    const insertedGroups = Math.ceil(priorTracks.length / 4);
    this.songs = [...priorTracks, ...(this.songs || [])];
    this.chunked_songs = this.chunk(this.songs, 4);
    this.playlistWindowOffset = resolvedOffset;

    // Prepending changes every slide index. Keep the song group the listener
    // was viewing in place, with the newly fetched groups available above it.
    await activeSlides.slideTo(insertedGroups, 0);
  } catch (error) {
    console.error('Unable to load previous playlist songs.', error);
    Swal2.fire({
      title: 'Could not load previous songs',
      icon: 'error',
      timer: 2200,
    });
  } finally {
    this._loadingMore = false;
  }
}

}
